import { render, staticRenderFns } from "./ControlePatrimonial.vue?vue&type=template&id=9d08009e&"
import script from "./ControlePatrimonial.vue?vue&type=script&lang=js&"
export * from "./ControlePatrimonial.vue?vue&type=script&lang=js&"
import style0 from "./ControlePatrimonial.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports